import searchReducer from "./search/search.reducer";

// For now, this application only has a single reducer
// Additional reducers can be added here by using
// combineReducers() from redux or rolling your
// own: http://redux.js.org/docs/recipes/reducers/BeyondCombineReducers.html

export default searchReducer;
